const actions = {
  /**
   * Sets the image style
   * @param {Object} style - A style object to apply to the image
   * @param {Number} id - The id of the component
   * @returns {Object} an event object with a payload
   */
  setImageStyle(style, id) {
    return {
      type: 'IMAGE_STYLE_CHANGED',
      style,
      id,
    };
  },


  /**
   * Shows an image's credits
   * @param {Number} id - The id of the component
   * @returns {Object} - A data object
   */
  showImageCredits(id) {
    return {
      type: 'SHOW_IMAGE_CREDITS',
      id,
    };
  },


  /**
   * Transitions in an image's credits
   * @param {Number} id - The id of the component
   * @returns {Object} - A data object
   */
  transitionInImageCredits(id) {
    return {
      type: 'TRANSITION_IN_IMAGE_CREDITS',
      id,
    };
  },


  /**
   * Hides an image's credits
   * @param {Number} id - The id of the component
   * @returns {Object} - A data object
   */
  hideImageCredits(id) {
    return {
      type: 'HIDE_IMAGE_CREDITS',
      id,
    };
  },


  /**
   * Transitions out an image's credits
   * @param {Number} id - The id of the component
   * @returns {Object} - A data object
   */
  transitionOutImageCredits(id) {
    return {
      type: 'TRANSITION_OUT_IMAGE_CREDITS',
      id,
    };
  },


  /**
   * Sets whether the content is dragging
   * @param {Boolean} dragging - If the content is dragging
   * @returns {Object} an event object with a payload
   */
  setDragging(dragging) {
    return {
      type: 'CONTENT_DRAGGING',
      dragging,
    };
  },


  /**
   * Sets whether the content is dragging
   * @param {Array<Object>} data - An array of data objects
   * @returns {Object} an event object with a payload
   */
  setCurrentCardData(data) {
    return {
      type: 'CARD_DATA_CHANGED',
      data,
    };
  },


  /**
   * Sets the current card iteration
   * @param {Number} iteration - The iteration of the current card
   * @returns {Object} an event object with a payload
   */
  setCurrentCardIteration(iteration) {
    return {
      type: 'CARD_CHANGED',
      iteration,
    };
  },


  /**
   * Sets the current card iteration
   * @param {Number} progress - The percentage of the cards the user has swiped
   * through
   * @returns {Object} an event object with a payload
   */
  setProgress(progress) {
    return {
      type: 'PROGRESS_CHANGED',
      progress,
    };
  },


  /**
   * Sets the loading status
   * @param {Boolean} loading - if the app is in the loading state
   * @returns {Object} an event object with a payload
   */
  setLoading(loading) {
    return {
      type: 'LOADING',
      loading,
    };
  },


  /**
   * Sets the window size
   * @returns {Object} - A data object
   */
  setWindowSize() {
    return {
      type: 'WINDOW_RESIZED',
      windowSize: {
        height: window.innerHeight,
        width: window.innerWidth,
      },
    };
  },


  /**
   * Sets whether a slideshow image is loading
   * @param {Number} id - The id of the component
   * @param {Boolean} loading - Whether the slideshow is loading
   * @returns {Object} - A data object
   */
  setSlideshowLoading(id, loading) {
    return {
      type: 'SLIDESHOW_LOADING',
      loading,
      id,
    };
  },


  /**
   * Sets whether a slideshow image is loading
   * @param {Number} id - The id of the component
   * @param {Number} slide - The active slide
   * @returns {Object} - A data object
   */
  setSlideshowActiveSlide(id, slide) {
    return {
      type: 'SLIDESHOW_ACTIVE_SLIDE_CHANGED',
      activeSlide: slide,
      id,
    };
  },


  /**
   * Sets whether a slideshow image is transitioning
   * @param {Number} id - The id of the component
   * @param {Boolean} transitioning - Whether the slideshow is transitioning
   * @returns {Object} - A data object
   */
  setSlideshowTransitioning(id, transitioning) {
    return {
      type: 'SLIDESHOW_TRANSITIONING',
      transitioning,
      id,
    };
  },


  /**
   * Sets whether a slideshow's first image is loaded
   * @param {Number} id - The id of the component
   * @param {Boolean} firstSlideLoaded - Whether the slideshow's first image
   * is loaded
   * @returns {Object} - A data object
   */
  setSlideshowFirstSlideLoaded(id, firstSlideLoaded) {
    return {
      type: 'SLIDESHOW_FIRST_SLIDE_LOADED',
      firstSlideLoaded,
      id,
    };
  },


  /**
   * Sets whether the default events should be prevnted while dragging
   * @param {Boolean} defaultEventsPrevented - Whether the default events
   * should be prevented while dragging
   * @returns {Object} - A data object
   */
  setDefaultEventsPrevented(defaultEventsPrevented) {
    return {
      type: 'DEFAULT_EVENTS_PREVENTED',
      defaultEventsPrevented,
    };
  },


  /**
   * Sets whether a card click event should be prevented
   * @param {Boolean} cardClickPrevented - Whether a the click event
   * should be prevented
   * @returns {Object} - A data object
   */
  setCardClickPrevented(cardClickPrevented) {
    return {
      type: 'CARD_CLICK_PREVENTED',
      cardClickPrevented,
    };
  },
};

export default actions;



/** WEBPACK FOOTER **
 ** ./assets/js/src/actions/small-card-actions.js
 **/